/**
 * @Author: Alex Sorafumo <Yuion>
 * @Date:   15/09/2016 12:32 PM
 * @Email:  alex@yuion.net
 * @Filename: btn.component.ts
 * @Last modified by:   Alex Sorafumo
 * @Last modified time: 07/02/2017 11:51 AM
 */

import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

import { BaseFormWidgetComponent } from '../../../../shared/base-form.component';

@Component({
    selector: 'btn',
    styles: [`.default{font-family:Roboto}.btn{display:inline-block}.group-item button{border-radius:0;margin:.5em 0}.group-item.n1 button{border-radius:4px 0 0 4px;margin-left:.5em}.group-item.nl button{border-radius:0 4px 4px 0;margin-right:.5em}button{border:1px solid #f0f0f0;border-radius:4px;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);cursor:pointer;font-size:1em;margin:.5em .25em;outline:0;overflow:hidden;padding:.5em .75em;position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:color .2s,background-color .2s,-webkit-box-shadow .2s;transition:color .2s,background-color .2s,box-shadow .2s,-webkit-box-shadow .2s}button:hover{-webkit-box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 4px 2px -2px rgba(0,0,0,.12);box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 4px 2px -2px rgba(0,0,0,.12)}button:active{-webkit-box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent;box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent}button.raised{min-width:6em}button.disabled{background-color:rgba(0,0,0,.2);color:rgba(0,0,0,.2);cursor:not-allowed}button.action,button.mini-action{border-radius:.8em;height:1.5em;padding:0;width:1.5em;max-width:1.5em;max-height:1.5em;min-width:1.5em;min-height:1.5em;overflow:hidden}button.action>*,button.mini-action>*{max-width:1.5em;overflow:hidden}button.action{font-size:1.5em}button.mini-action{font-size:1.2em}button.flat{min-width:6em}.content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}`],
    template: `<!--
@Author: Alex Sorafumo <Yuion>
@Date:   13/09/2016 3:46 PM
@Email:  alex@yuion.net
@Filename: btn.template.html
@Last modified by:   alex.sorafumo
@Last modified time: 20/01/2017 2:45 PM
-->

<div [class]="'btn' + (klass ? ' ' + klass : '')" widget>
    <button click-responder #btn [type]="type" [class]="format" [class.active]="model" [disabled]="disabled" (touchrelease)="tap($event)">
        <div class="content">
            <ng-content></ng-content>
        </div>
    </button>
</div>
`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent extends BaseFormWidgetComponent<boolean> {
    // Component Inputs
    @Input() public type = 'button';
    @Input() public format = 'raised';
    @Input() public toggle = false;
    // Output emitters
    @Output() public tapped = new EventEmitter();

    constructor(protected _cdr: ChangeDetectorRef) {
        super();
    }

    public tap(e: MouseEvent | TouchEvent) {
        this.timeout('tap', () => {
            if (this.toggle) {
                this.model = !this.model;
                this.modelChange.emit(this.model);
            }
            this.tapped.emit(e);
        }, 300);
    }
}
